import { defineMessages } from 'react-intl';

export { NavigationTypes } from './externals';

export const messages = defineMessages({
  viewAll: {
    id: 't.viewAll',
    defaultMessage: 'View All',
  },
  stationsCount: {
    id: 't.stationsCount',
    defaultMessage: `{stationCount, plural,
      one {# station}
      other {# stations}
    }`,
  },
  listenersCount: {
    id: 't.listenersCount',
    defaultMessage: `{humanCount} {listenerCount, plural,
      one {Listener}
      other {Listeners}
    }`,
  },
  songsCount: {
    id: 't.songsCount',
    defaultMessage: `{songCount, plural,
      one {# song}
      other {# songs}
    }`,
  },
  browseInApp: {
    id: 't.browseInApp',
    defaultMessage: 'Browse In App',
  },
  loadingBrowse: {
    id: 't.loadingBrowse',
    defaultMessage: 'Loading Browse',
  },
});

export const DiscoveryKeys = Object.freeze({
  BROWSE: 'browse',
  DEEP_LEVEL_SECTIONS: 'deepLevelSections',
  FETCHING_OFFSETS: 'fetchingOffsets',
  IS_FETCHING: 'isFetching',
  IS_INVALID_URL: 'isInvalidUrl',
  MODULES: 'modules',
  MODULES_BY_ID: 'modulesById',
  TOP_LEVEL: 'topLevel',
  TOP_LEVEL_SECTIONS: 'topLevelSections',
  WEB_URL: 'webUrl',
} as const);

export const BROWSE_BASE_PATH = '/browse';
export const API_ITEM_LIMIT = 20;

export const ActionTypes = Object.freeze({
  GET_BROWSE_DIRECTORY: 'GET_BROWSE_DIRECTORY',
  INGEST_BROWSE_DIRECTORY_DATA: 'INGEST_BROWSE_DIRECTORY_DATA',
} as const);
